module.exports = __webpack_public_path__ + "img/CircleColor4.48aa4735.png";